var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconfont codics-simple-shortcut-body"})
}
var staticRenderFns = []

export { render, staticRenderFns }